import React, { useEffect, useState } from "react";
import Card from "../../../common/card/Card";
import Title from "../../../common/title/Title";
import GroupDashboardCardHeader from "../GroupDashboardCardHeader";
import GroupDashboardCardBody from "../GroupDashboardCardBody";
import GroupDashboardCardFooter from "../GroupDashboardFooter";
import {
  Column,
  Table,
  useReactTable,
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  sortingFns,
  getSortedRowModel,
  FilterFn,
  SortingFn,
  ColumnDef,
  flexRender,
  FilterFns,
  createColumnHelper,
  SortingState,
} from '@tanstack/react-table'
import BreadCrumbs from "../../../common/breadcrumbs/BreadCrumbs";
import Loader from "../../../common/loader/Loader";
import { useNavigate } from 'react-router-dom'
import { useGroupDashboardContext } from "../GroupDashboardContext";

const Organizations = ( props:any ) => {

  const navigate = useNavigate()
  const [ isLoading, setIsLoading ] = useState(true)
  const organizationData = JSON.parse( props['data-organizations'] ) ?? []
  const teamOptionsData = JSON.parse(props['data-team-options'] || '{}');
  const siteFiltersData = JSON.parse(props['data-site-filters'] || '{}')
  const { setFiltersData } = useGroupDashboardContext()

  const [ sorting, setSorting ] = React.useState<SortingState>([])

  type Organization = {
    ownerId: number,
    teamId: number,
    planId: number,
    title: string,
    created: string,
    members: number,
    remainingSeatCount: number,
    seatCount: number,
    subscription: Array<{
      subscription_id: number,
      subscription_status: string
    }>,
    profile: {},
  }

  const defaultData: Organization[] = organizationData

  const columnHelper = createColumnHelper<Organization>()
  const columns = [
    columnHelper.accessor('ownerId', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('teamId', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('planId', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('title', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('created', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('members', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('remainingSeatCount', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('seatCount', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('subscription', {
      cell: info => info.getValue()
    }),
    columnHelper.accessor('profile', {}),
  ]

  const [ data, setData ] = React.useState(() => [...defaultData])
  const [ globalFilter, setGlobalFilter ] = React.useState('')
  const pageSize = [ 4, 8, 12, 16, 20 ]

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      globalFilter
    },
    initialState: {
      pagination: {
          pageSize: pageSize[0],
      },
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  })

  useEffect(() => {

    setFiltersData( siteFiltersData );

    if( Object.keys( organizationData ).length === 1 ){
      const thisOrganization = organizationData[0]
      const teamId = thisOrganization['teamId'] ?? 0
      if( !teamId ) return 
      
      let link = `/organization/${teamId}`

      if( !thisOrganization['canManage'] ){
        link = `/organization/${teamId}/member-home`
      }
  
      navigate(`${link}`)
      return
    }

    setTimeout(() => {
      setIsLoading(false)
    }, 500)
  }, [])

  return(
    <>
      {
        isLoading
        ? <Loader type='spinner-dual-ring'/>
        : <>
          <div className='msync-organization-dashboard__header'>
            <BreadCrumbs breadcrumbs={ props.breadcrumbs } />
          </div>
          <Title value={siteFiltersData.woo.teams.plural_label} />
          <div className='msync-organization-dashboard__body'>
            <Card>
              <GroupDashboardCardHeader
                globalFilter={ globalFilter } 
                setGlobalFilter={ setGlobalFilter } 
                setSorting={ setSorting }
              />
              <div className="msync-card__body msync-organization-dashboard-orgsListing">
                <GroupDashboardCardBody data={ table } teamOptionsData={ teamOptionsData } />
              </div>
              <GroupDashboardCardFooter 
                data={ table } 
                pageSize={ pageSize }
              />
            </Card>
          </div>
        </>
      }
    </>
  )

}

export default Organizations
